import React from 'react'
import baseUrl from '../../../../config/baseUrl'
import { Box, Button, Tooltip, IconButton, Stack, Typography } from '@mui/material'
import { useSnackbar } from '../../../../components/SnackbarProvider'
import { CheckIcon } from '../../../../components/Icons'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import InfoIcon from '@mui/icons-material/Info'

const Plans = (Props) => {
  const { plan, subscribedPlanId, subscribedBasicPlan, planExpiryDate } = Props

  // console.log(plan, subscribedPlanId, subscribedBasicPlan, planExpiryDate)
  const subscribedPlan = JSON.parse(sessionStorage.getItem('subscriptionUserPlanIds'))
  const [isSubscribedToFJP, setIsSubscribedToFJP] = React.useState(false)

  React.useEffect(() => {
    subscribedPlan &&
      subscribedPlan.map(
        (item) => item && item?.PlanName === 'First Justice Plan' && setIsSubscribedToFJP(true),
        // (item) => item && item?.PlanName === 'First Justice Plan' && console.log(item?.PlanName),
      )
  }, [])

  // if (isSubscribedToFJP) {
  //   console.log('isSubscribedToFJP', isSubscribedToFJP)
  // } else {
  //   // setIsSubscribedToFJP(false)
  //   console.log('isSubscribedToFJP', isSubscribedToFJP)
  // }

  if (!!subscribedPlan && planExpiryDate === Date.now()) {
    setIsSubscribedToFJP(true)
  }

  const givenDate = new Date(planExpiryDate)
  const currentDate = new Date()
  const showSnackbar = useSnackbar()
  // console.log('plan, subscribedPlanId, onClose', plan, subscribedPlanId, onClose)

  const userId = sessionStorage.getItem('userId')
  const token = sessionStorage?.getItem('token')

  const handleUpgradePlan = async (plan) => {
    // Validation
    if (!plan?.id || !plan?.Price) {
      showSnackbar('Invalid plan data', 'error')
      return
    }

    if (!userId || !token) {
      showSnackbar('User not authenticated', 'error')
      return
    }

    try {
      const subscriptionResponse = await fetch(`${baseUrl}/api/order/create`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          authorization: token,
        },
        body: JSON.stringify({
          userid: userId,
          amount: plan.Price,
          subscriptionid: plan.id,
        }),
      })

      // // Handle HTTP errors first
      // if (!subscriptionResponse.ok) {
      //   const errorData = await subscriptionResponse.json().catch(() => ({}))
      //   showSnackbar(errorData.message || `Server error: ${subscriptionResponse.status}`, 'error')
      //   return
      // }

      const subscriptionResponseData = await subscriptionResponse.json()

      // Handle business logic errors
      if (subscriptionResponseData.status === false) {
        showSnackbar(subscriptionResponseData.message || 'Subscription failed', 'error')
        return
      }

      // Validate payment link exists
      if (!subscriptionResponseData.payment_link) {
        showSnackbar('Payment link not received', 'error')
        return
      }

      // Redirect to payment
      window.open(subscriptionResponseData.payment_link, '_self')
    } catch (error) {
      showSnackbar(`Error in upgrade subscription: ${error?.message}`, 'error')
    }
  }

  return (
    <Box
      position='relative'
      sx={{ minWidth: { xs: 'calc(25%)', sm: 'calc(35%)' }, maxWidth: { xs: '100%', sm: 'auto' } }}
      border='0.5px solid'
      borderColor='primary.main'
      borderRadius={1}
      boxShadow='0px 0px 12px rgba(0, 0, 0, 0.08)'
      bgcolor='common.white'
      p={1.5}
      spacing={2.5}
      zIndex={1}
    >
      <Box>
        <Stack spacing={1}>
          <Box display='flex' alignItems='center' justifyContent='space-between'>
            <Typography color='textSecondary'>
              <span style={{ fontWeight: 'bold', fontSize: '16px' }}>{`${plan?.PlanName} : `}</span>
              <span>
                (
                <span
                  style={{ fontSize: '14px', fontWeight: 'bold', color: 'green' }}
                >{` ${plan?.Validity} Days`}</span>
                )
              </span>
            </Typography>
            {/* {plan?.PlanName !== 'Basic' && ( */}
            <Button
              onClick={() => {
                handleUpgradePlan(plan)
              }}
              variant='contained'
              sx={{ maxWidth: 146, height: 40, p: 0, display: { xs: 'none', sm: 'block' } }}
              disabled={
                (subscribedPlanId === plan?.id && givenDate > currentDate) ||
                (!subscribedPlanId && plan?.PlanName === 'Top-up') ||
                (subscribedPlanId && plan?.PlanName === 'Top-up' && isSubscribedToFJP) ||
                (subscribedBasicPlan && plan?.PlanName === 'Basic') ||
                (subscribedBasicPlan && plan?.PlanName === 'First Justice Plan') ||
                (plan?.PlanName === 'First Justice Plan' && isSubscribedToFJP)
              }
            >
              {subscribedPlanId === plan?.id && givenDate > currentDate
                ? 'Subscribed'
                : 'Upgrade Plan'}
              {/* {subscribedPlanId === 1 && plan?.name === 'Top-up' ? 'Subscribed' : 'Upgrade Plan'} */}
            </Button>
            {/* )} */}

            {/* <VisibilityBlackIcon sx={{ width: 20, height: 20, color: 'success.main' }} /> */}
          </Box>
          {/* <Button variant='contained' disabled sx={{ maxWidth: 146, height: 40, p: 0 }}>
          Current Plan
        </Button> */}
        </Stack>
        <Stack spacing={1} zIndex={3}>
          <Box display='flex' alignItems='flex-start'>
            <CheckIcon sx={{ width: 20, mr: 1.5, color: 'primary.main' }} />
            <Typography variant='subtitle1'>
              Price : <span>&#8377;</span> {plan?.Price?.toLocaleString('en-US')}
            </Typography>
          </Box>

          {/* <Box display='flex' alignItems='flex-start'>
          <CheckIcon sx={{ width: 20, height: 20, mr: 1.5, color: 'primary.main' }} />
          <Typography variant='subtitle1'>Features : {plan?.Features}</Typography>
        </Box> */}

          {/* Tokens */}
          <Box
            sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
            zIndex={4}
            position='relative'
          >
            <CheckIcon sx={{ width: 20, mr: 1.5, color: 'primary.main' }} />
            <Typography variant='subtitle1'>
              Tokens : {plan?.Totaltoken?.toLocaleString('en-US')}
            </Typography>
          </Box>

          {/* Words approx */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              position: 'relative',
              zIndex: 4,
            }}
          >
            <CheckIcon sx={{ width: 20, mr: 1.5, color: 'primary.main' }} />

            <Typography variant='subtitle1'>
              Words (approx) : {Math.ceil((plan?.Totaltoken * 75) / 100).toLocaleString('en-US')}
            </Typography>

            <Tooltip
              sx={{ zIndex: '10002 !important' }}
              disableFocusListener
              title={`${plan?.Totaltoken} tokens is equal to ${Math.ceil(
                (plan?.Totaltoken * 75) / 100,
              )} words`}
              placement='right'
            >
              <IconButton sx={{ ml: '0.5rem', p: 0 }}>
                <InfoIcon sx={{ color: '#777' }} />
              </IconButton>
            </Tooltip>
          </Box>

          {/* Upgrade plan button */}
          <Box display='flex' sx={{ justifyContent: { xs: 'space-between', sm: 'flex-end' } }}>
            <Button
              onClick={() => {
                handleUpgradePlan(plan)
              }}
              variant='contained'
              sx={{ maxWidth: 146, height: 40, p: 0, display: { xs: 'block', sm: 'none' } }}
              disabled={
                (subscribedPlanId === plan?.id && givenDate > currentDate) ||
                (!subscribedPlanId && plan?.PlanName === 'Top-up') ||
                (subscribedBasicPlan && plan?.PlanName === 'Basic') ||
                (subscribedBasicPlan && plan?.PlanName === 'First Justice Plan') ||
                (plan?.PlanName === 'Top-up' && isSubscribedToFJP) ||
                (plan?.PlanName === 'First Justice Plan' && isSubscribedToFJP)
              }
            >
              {subscribedPlanId === plan?.id && givenDate > currentDate
                ? 'Subscribed'
                : 'Upgrade Plan'}
              {/* {subscribedPlanId === 1 && plan?.name === 'Top-up' ? 'Subscribed' : 'Upgrade Plan'} */}
            </Button>
            {subscribedPlanId === plan?.id && givenDate > currentDate && (
              <CheckBoxIcon color='success' fontSize='large' />
            )}
          </Box>
          {plan?.PlanName === 'Top-up' && (
            <Typography variant='body2' fontSize='12px' color='red' component='p' align='right'>
              Top-up plan is only for <strong>subscribed</strong> users
            </Typography>
          )}
          {plan?.PlanName === 'First Justice Plan' && isSubscribedToFJP && (
            <Typography variant='body2' fontSize='12px' color='red' component='p' align='right'>
              For one time purchase only.
            </Typography>
          )}
          {/* {plan?.PlanName === 'Basic' && (
          <Typography variant='body1' fontSize='12px' color='green' component='p' align='right'>
            <strong>Free Plan</strong>
          </Typography>
        )} */}
        </Stack>
      </Box>
    </Box>
  )
}

export default Plans
